import { Module } from "wrapper6";
import ObjectFitPolyfill from '../utils/_object-fit-polyfill';

export default class ObjectFit extends Module {
    ready() {
        const OBJECT_FIT = new ObjectFitPolyfill();
        OBJECT_FIT.init();
    }
}